import { render, staticRenderFns } from "./MainContainer.vue?vue&type=template&id=01977636"
import script from "./MainContainer.vue?vue&type=script&lang=js"
export * from "./MainContainer.vue?vue&type=script&lang=js"
import style0 from "./MainContainer.vue?vue&type=style&index=0&id=01977636&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports